<script setup>
import AutocompleteFilter from '@/components/widgets/AutocompleteFilter.vue';
import { inject, onMounted, ref } from 'vue';
import { useInfinite } from '@/composables/use-infinity';

const backendApi = inject('backendApi');
const selected = ref(null);

const fetchCountries = ({ pattern, page, limit }) =>
    backendApi().country().index({
        pattern,
        active: true,
        page,
        limit
    });

const {
    items: countries,
    loading: isLoading,
    showRetryButton,
    hasMore,
    searchQuery,
    getItems,
    loadMore,
    reset
} = useInfinite(fetchCountries);

const emit = defineEmits(['update']);

const handleSearch = () => {
    reset();
    getItems();
};

onMounted(() => {
    getItems();
});
</script>

<template>
    <AutocompleteFilter
        v-model="selected"
        v-model:search="searchQuery"
        :item-title="'name'"
        :item-value="'id'"
        :items="countries"
        :label="$t('Country')"
        :loading="isLoading"
        :show-retry-button="showRetryButton"
        :infinite-scroll="hasMore"
        @infinite-scroll="loadMore"
        @update="emit('update', selected)"
        @preparing-search="handleSearch"
        @search="handleSearch"
        @retry="handleSearch"
    >
        <template v-slot:default="{ props, item }">
            <v-list-item
                v-bind="props"
                :title="item.raw.name"
                :subtitle="item.raw.code"
            />
        </template>
    </AutocompleteFilter>
</template>
